import {
    EMPTY_SEARCH,
} from './constants';

export const emptySearch = () => ({
    type: EMPTY_SEARCH
});


/**
 *  ASYNC ACTIONS
 */



// WEBPACK FOOTER //
// ./src/containers/Search/store/actions.js